import AnnouncementBar from "./components/AnnouncementBar";
import Navbar from "./components/Navbar";
import HeroContainer from "./components/HeroContainer";

export default function Home() {
  return (
    <main className="bg-white h-screen flex flex-col overflow-hidden">
      <AnnouncementBar />
      <Navbar />
      <HeroContainer />
    </main>
  );
}